/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedProductRequestDto } from '../../models/backend-patched-product-request-dto';
import { BackendProductDto } from '../../models/backend-product-dto';

export interface OpexesProductsPartialUpdate$Params {
  id: number;
  body?: BackendPatchedProductRequestDto;
}

export function opexesProductsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: OpexesProductsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProductDto>> {
  const rb = new RequestBuilder(rootUrl, opexesProductsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProductDto>;
    }),
  );
}

opexesProductsPartialUpdate.PATH = '/api/opexes/products/{id}/';
